export const FIELD_SALES_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Field Sales Form', href: '/fieldsalesform', icon: 'cilUserFollow', organisationIds: [1, 4] },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },

  { slug: 'title', name: 'CRM & Calls' },
  { slug: 'link', name: 'Field Visits', href: '/fieldvisits', icon: 'cilLocationPin', organisationIds: [1, 4] },
  // { slug: 'link', name: 'Feedback Call', href: '/feedback_call', icon: 'cilCommentSquare' },
  // {
  //   slug: 'dropdown',
  //   name: 'Follow Ups',
  //   icon: 'cilTask',
  //   elements: [
  //     { slug: 'link', name: 'Customer Follow Ups', href: '/customer_followups', icon: 'cilCommentSquare' },
  //     { slug: 'link', name: 'Grade Followups', href: '/grade_followups', icon: 'cilStar' },
  //   ],
  // },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
